export enum StrategyType {
  Current = 1,
  New = 2,
}